import moment from 'moment';

const MAX_EVENT_DATE_RANGE_YEARS = 3;

/**
 * 判断所选开始/结束日期的跨度是否超过 3 年。
 * 仅比较 startTime 与 endTime 的间隔，与当前日期无关。
 */
export function isOpinionEventDateRangeExceeded(
  startTime?: string,
  endTime?: string,
): boolean {
  if (!startTime || !endTime) {
    return false;
  }

  const start = moment(startTime);
  const end = moment(endTime);

  if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
    return false;
  }

  return start
    .clone()
    .add(MAX_EVENT_DATE_RANGE_YEARS, 'years')
    .isBefore(end, 'day');
}
